import React, { lazy, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { rcsClickTrackingURL, rcsTrack } from '../../functions/rcsTrack';
import SuspenseWrapper from '../common/suspenseWrapper';
const ItemOptionsPopup = lazy(() =>
  import(/* webpackChunkName:"VariantsAddonsPopUp"*/ '../popUp/itemOptions')
);

const AddOnVarient = ({
  item,
  close,
  updateCart,
  customize,
  allPrices,
  variations,
  isAddonAvailable,
  finalQuantity,
  incrementFunction,
  decrementFunction,
  setFinalQuantity,
}) => {
  const [showVarientAddon, setShowVarientAddon] = useState(
    variations?.length > 0 || isAddonAvailable
  );

  const { bestSellerItems } = useSelector((state) => state.recommendations);

  const varientDisplayed = (addOns, selectedVariationData) => {
    setShowVarientAddon(false);
    updateCart(item.id, finalQuantity, addOns, selectedVariationData);
  };

  useEffect(() => {
    if (customize) {
      setFinalQuantity(item?.quantity);
    } else {
      setFinalQuantity(1);
    }
  }, []);

  useEffect(() => {
    let clickTrackingURLFromMenuItem;
    if (!item?.clickTrackingURL) {
      clickTrackingURLFromMenuItem =
        bestSellerItems.find((bitem) => bitem?.id === item?.id)?.clickTrackingURL || '';
    }
    const finalClickTrackingURL = item?.clickTrackingURL || clickTrackingURLFromMenuItem;
    if (finalClickTrackingURL) {
      rcsClickTrackingURL(finalClickTrackingURL);
    }
    rcsTrack('itemPage', { itemId: item.id });
  }, []);

  return (
    <>
      {showVarientAddon && (
        <SuspenseWrapper>
          <ItemOptionsPopup
            item={item}
            customize={customize}
            allPrices={allPrices}
            variations={variations}
            isAddonAvailable={isAddonAvailable}
            closePopup={close}
            finalQuantity={finalQuantity}
            varientDisplayed={varientDisplayed}
            incrementFunction={incrementFunction}
            decrementFunction={decrementFunction}
            setFinalQuantity={setFinalQuantity}
          />
        </SuspenseWrapper>
      )}
    </>
  );
};

export default AddOnVarient;
